import * as R from "ramda";
import {removeNullFields} from "../../../common/mapper";

const validate = (data, notEquals, signedBy) => {
    let newErrors = {};
    if (R.or(R.isNil(data?.jpTac1Amount),
        typeof parseFloat(data?.jpTac1Amount) !== 'number',
        isNaN(parseFloat(data?.jpTac1Amount)))) {
        newErrors.jpTac1Amount = "Field belum diisi";
    }

    if (R.or(!data?.bastFotoSmhBase64, R.isNil(data?.bastFotoSmhBase64))) {
        newErrors.fotoBastSmhBase64 = "Field belum diisi";
    }

    newErrors = removeNullFields({
        ...newErrors,
        ...validateNotEquals(notEquals),
        ...validateDataCetakan(data.dataCetakan, signedBy),
    });

    return newErrors;
};

const validateNotEquals = (notEquals) => {
    if (notEquals) {
        return ({
            jpTac1Amount: "Jumlah Jasa Perantara Belum Sesuai",
            jpTac2Amount: "Jumlah Jasa Perantara Belum Sesuai",
            jpTac3Amount: "Jumlah Jasa Perantara Belum Sesuai",
        });
    }
};

const validateDataCetakan = (data, signedBy) => {
    let included = ["recipient", "receiptDate", "receiptPurpose"];
    let newErrors = {};
    if (R.or(R.isNil(signedBy), R.isNil(signedBy?.value))) {
        newErrors.signedBy = "Field belum diisi";
    }
    if (R.or(R.isNil(data), R.isEmpty(data))) {
        newErrors.dataCetakan = "Field belum diisi";
    } else {
        newErrors.dataCetakan = [];
        data.forEach((item, idx) => {
            newErrors.dataCetakan[idx] = {};
            included.forEach(key => {
                if (R.or(R.isNil(item?.[key]), R.isEmpty(item?.[key], !item?.[key]))) {
                    newErrors.dataCetakan[idx][key] = "Field belum diisi";
                }
            })
        });
    }
    return newErrors;
}

const constructDataCetakan = (data) => {
    return data.map(item => {
        return removeNullFields({
            ...item,
            signedBy: item.signedBy?.value || null,
        });
    });
};

export const service = {
    validate,
    constructDataCetakan,
    validateNotEquals,
};